<div class="row d-flex w-100 mt-3 bidder-info-container">
    <div [ngClass]="{'col-12': !showAdditionalInfo}" class="col-7 bidder-info-container--grey">
        <div>
            <div class="d-flex align-items-center">
                <span class="subtitle-1--weight-bold mr-2">{{selectedBidder.userInfo.name}}</span>

                @if(fundingSource) {
                    <svg initTooltip [attr.title]="fundingSource.sourceName" placement="top" viewBox="0 0 32 21" style="width: 20px;">
                        <g fill="green" fill-rule="evenodd">
                            <g class="Icon-fill">
                                <g transform="translate(0 2)">
                                    <path d="M26.58 19H2.42A2.4 2.4 0 0 1 0 16.62V2.38A2.4 2.4 0 0 1 2.42 0h24.16A2.4 2.4 0 0 1 29 2.38v14.25A2.4 2.4 0 0 1 26.58 19zM10 5.83c0-.46-.35-.83-.78-.83H3.78c-.43 0-.78.37-.78.83v3.34c0 .46.35.83.78.83h5.44c.43 0 .78-.37.78-.83V5.83z" opacity=".2"></path>
                                    <path d="M25 15h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0H4c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1z" opacity=".3"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                }
            </div>
            
            <span class="body-3 grey-text font-weight-400">{{selectedBidder.userInfo.email}}</span>
            @if (showSeeCart) {
                <br>
                <span (click)="openSeeCartModal()" class="body-2 blue-text cursor--pointer">See Cart</span>
            }
        </div>
        <div class="row mt-2">
            <ng-container *ngIf="auction?.phoneNumRequired">
                <div [ngClass]="{'col-12': !bidderAddress}" *ngIf="selectedBidder.userInfo?.phone" class="col-5">
                    <span class="subtitle-2">Phone</span>
                    <br>
                    <span class="subtitle-2--regular">{{selectedBidder.userInfo?.phone}}</span>
                </div>
            </ng-container>
            <ng-container *ngIf="auction?.streetAddressRequired">
                <div [ngClass]="{'col-12': !selectedBidder.userInfo?.phone}" *ngIf="bidderAddress" class="col-7">
                    <span class="subtitle-2">Street Address</span>
                    <br>
                    <span class="subtitle-2--regular">{{bidderAddress}}</span>
                </div>
            </ng-container>
        </div>
    </div>
    <div *ngIf="showAdditionalInfo" class="col-5 bidder-info-container--white">
        <div *ngIf="auction.additionalInfoDesc && selectedBidder.additionalInfo">
            <span class="d-flex subtitle-2 mb-1">{{auction.additionalInfoDesc}}</span>
            <app-read-more [text]="selectedBidder.additionalInfo" [options]="readMoreOptions" class="subtitle-2--regular"></app-read-more>
        </div>
        <div *ngIf="auction.additionalInfoSelectDesc && selectedBidder.additionalInfoSelect" class="mt-2">
            <span class="d-flex subtitle-2 mb-1">{{auction.additionalInfoSelectDesc}}</span>
            <app-read-more [text]="selectedBidder.additionalInfoSelect" [options]="readMoreOptions" class="subtitle-2--regular"></app-read-more>
        </div>
    </div>
</div>

<div class="mt-4">
    <mdb-tabs class="mdb-tabs mdb-tabs--auction w-100">
        <mdb-tab title="Bids ({{allBidsCount}})">
            @if (allBidsCount > 0) {
                <div class="row subtitle-2--regular">
                    <div class="col-3 d-flex justify-content-center">
                        <span>Item Image</span>
                    </div>
                    <div class="col-3 d-flex justify-content-center text-center">
                        <span>Item Name</span>
                    </div>
                    <div class="col-2 d-flex justify-content-center">
                        <span>Amount</span>
                    </div>
                    <div class="col-2 d-flex justify-content-center text-nowrap">
                        Added By
                    </div>
                    <div class="col-2 d-flex justify-content-center">
                        <span>Time</span>
                    </div>
                    <hr class="w-100">
                </div>
                <div *ngFor="let bid of currentBidder.bids" class="d-flex row body-2 align-items-center mb-2">
                    <div (click)="openItemDetails(bid)" class="col-3 d-flex justify-content-center cursor--pointer">
                        <img *ngIf="bid.optionInfo?.imageUrl" [src]="bid.optionInfo.imageUrl" class="auction-item-img" alt="Auction Item">
                        <img *ngIf="!bid.optionInfo?.imageUrl" src="images/org_logo_default_v2.svg" class="auction-item-img" alt="Auction Item">
                    </div>
                    <div class="col-3 d-flex justify-content-center text-center">
                        <span (click)="openItemDetails(bid)"  class="auction-option-name px-1 py-2 cursor--pointer">{{bid.optionInfo.name}}</span>
                    </div>
                    <div class="col-2 d-flex justify-content-center">
                        <span>{{bid.amount | currency:'USD':'symbol-narrow':'1.0-0'}}</span>
                    </div>
                    <div class="col-2 d-flex justify-content-center">
                        @if (!bid.volunteerInfo && !bid.isAutoBid) {
                            Self
                        } @else if (bid.volunteerInfo) {
                            {{bid.volunteerInfo.name}}
                        } @else if (bid.isAutoBid) {
                            AutoBid
                        }
                    </div>
                    <div class="col-2 d-flex justify-content-center">
                        <span>{{bid.created}}</span>
                    </div>
                </div>
            } 
            @else if (allBidsCount === 0) {
                <div class="d-flex body-1 justify-content-center mt-3"> No Existing Bids... </div>
            }
        </mdb-tab>

        <mdb-tab title="AutoBids ({{allAutoBidsCount}})">
            @if (allAutoBidsCount > 0) {
                <div class="row subtitle-2--regular">
                    <div class="col-3 d-flex justify-content-center">
                        <span>Item Image</span>
                    </div>
                    <div class="col-3 d-flex justify-content-center text-center">
                        <span>Item Name</span>
                    </div>
                    <div class="col-2 d-flex justify-content-center">
                        <span>Max Bid</span>
                    </div>
                    <div class="col-1 d-flex justify-content-center">
                        <span>Status</span>
                    </div>
                    <div class="col-3 d-flex justify-content-center">
                        <span>Time</span>
                    </div>
                    <hr class="w-100">
                </div>
                <div *ngFor="let autoBid of currentBidder.autoBids" class="d-flex row body-2 align-items-center mb-2">
                    <div (click)="openItemDetails(autoBid)" class="col-3 d-flex justify-content-center cursor--pointer">
                        <img *ngIf="autoBid.optionInfo?.imageUrl" [src]="autoBid.optionInfo.imageUrl" class="auction-item-img" alt="Auction Item">
                        <img *ngIf="!autoBid.optionInfo?.imageUrl" src="images/org_logo_default_v2.svg" class="auction-item-img" alt="Auction Item">
                    </div>
                    <div class="col-3 d-flex justify-content-center text-center">
                        <span (click)="openItemDetails(autoBid)"  class="auction-option-name px-1 py-2 cursor--pointer">{{autoBid.optionInfo.name}}</span>
                    </div>
                    <div class="col-2 d-flex justify-content-center">
                        <span>{{autoBid.amount | currency:'USD':'symbol-narrow':'1.0-0'}}</span>
                    </div>
                    <div class="col-1 d-flex justify-content-center">
                        <span>{{autoBid.exhausted ? 'Done' : 'Active'}}</span>
                    </div>
                    <div class="col-3 d-flex justify-content-center">
                        <span>{{autoBid.created}}</span>
                    </div>
                </div>
            } 
            @else if (allAutoBidsCount === 0) {
                <div class="d-flex body-1 justify-content-center mt-3"> No Existing AutoBids... </div>
            }
        </mdb-tab>

        <mdb-tab title="Paid ({{allSoldItemsCount}})">
            @if (allSoldItemsCount > 0) {
                <div class="row subtitle-2--regular">
                    <div class="col-3 d-flex justify-content-center">
                        <span>Item Image</span>
                    </div>
                    <div class="col-3 d-flex justify-content-center">
                        <span>Item Name</span>
                    </div>
                    <div class="col-2 d-flex justify-content-center">
                        <span>Amount</span>
                    </div>
                    <div class="col-1 d-flex justify-content-center">
                        <span>Status</span>
                    </div>
                    <div class="col-3 d-flex justify-content-center">
                        <span>Time</span>
                    </div>
                    <hr class="w-100">
                </div>
                <div *ngFor="let item of currentBidder.paidItems" class="d-flex row body-2 align-items-center mb-2">
                    <div (click)="openItemDetails(item.campaignPreset)" class="col-3 d-flex justify-content-center cursor--pointer">
                        <img *ngIf="item.campaignPreset.imageUrl" [src]="item.campaignPreset.imageUrl" class="auction-item-img" alt="Auction Item">
                        <img *ngIf="!item.campaignPreset.imageUrl" src="images/org_logo_default_v2.svg" class="auction-item-img" alt="Auction Item">
                    </div>
                    <div class="col-3 d-flex justify-content-center text-center">
                        <span (click)="openItemDetails(item.campaignPreset)" class="auction-option-name px-1 py-2 cursor--pointer">{{item.campaignPreset.name}}</span>
                    </div>
                    <div class="col-2 d-flex justify-content-center ">
                        <span>{{item.amount | currency:'USD':'symbol-narrow':'1.0-0'}}</span>
                    </div>
                    <div *ngIf="!item.delivered && item.status == 0" class="col-1 d-flex justify-content-center">
                        <span>Paid</span>
                    </div>
                    <div *ngIf="item.status == 1" class="col-1 d-flex justify-content-center">
                        <span>Pending</span>
                    </div>
                    <div *ngIf="item.delivered && item.status == 0" class="col-1 d-flex justify-content-center">
                        <span>Delivered</span>
                    </div>
                    <div class="col-3 d-flex justify-content-center">
                        <span>{{item.created}}</span>
                    </div>
                </div>
            } 
            @else if (allSoldItemsCount === 0) {
                <div class="d-flex body-1 justify-content-center mt-3"> No Paid Items... </div>
            }
        </mdb-tab>

        <mdb-tab title="Pending ({{allPendingItemsCount}})">
            @if (allPendingItemsCount > 0) {     
                <div class="row subtitle-2--regular">
                    <div class="col-3 d-flex justify-content-center">
                        <span>Item Image</span>
                    </div>
                    <div class="col-3 d-flex justify-content-center">
                        <span>Item Name</span>
                    </div>
                    <div class="col-2 d-flex justify-content-center">
                        <span>Amount</span>
                    </div>
                    <div class="col-3 d-flex justify-content-center">
                        <span>Time</span>
                    </div>
                    <hr class="w-100">
                </div>
                <div *ngFor="let item of currentBidder.pendingItems" class="d-flex row body-2 align-items-center mb-2">
                    <div (click)="openItemDetails(item.donationInfo.campaignPreset)" class="col-3 d-flex justify-content-center cursor--pointer">
                        <img *ngIf="item.donationInfo.campaignPreset.imageUrl" [src]="item.donationInfo.campaignPreset.imageUrl" class="auction-item-img" alt="Auction Item">
                        <img *ngIf="!item.donationInfo.campaignPreset.imageUrl" src="images/org_logo_default_v2.svg" class="auction-item-img" alt="Auction Item">
                    </div>
                    <div class="col-3 d-flex justify-content-center text-center">
                        <span (click)="openItemDetails(item.donationInfo.campaignPreset)" class="auction-option-name px-1 py-2 cursor--pointer">{{item.donationInfo.campaignPreset.name}}</span>
                    </div>
                    <div class="col-2 d-flex justify-content-center ">
                        <span>{{item.item.amount | currency:'USD':'symbol-narrow':'1.0-0'}}</span>
                    </div>
                    <div class="col-3 d-flex justify-content-center">
                        <span>{{item.created}}</span>
                    </div>
                </div>
            } 
            @else if (allPendingItemsCount === 0) {
                <div class="d-flex body-1 justify-content-center mt-3"> No Pending Items... </div>
            }
        </mdb-tab>
    </mdb-tabs>
</div>